import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog';
import { api } from '@/lib/api';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '@/state/use-admin';

interface LogoutDialogProps {
	isOpen: boolean;
	onClose: () => void;
}

const LogoutDialog: React.FC<LogoutDialogProps> = ({ isOpen, onClose }) => {
	const [error, setError] = useState('');
	const navigate = useNavigate();
	const { clearUser } = useAdmin(state => ({ clearUser: state.clearUser }));

	const handleLogout = async () => {
		setError('');
		try {
			await api.post('/auth/logout');
			clearUser();
			onClose();
			navigate('/login');
		} catch (err) {
			setError('退出登录失败，请稍后再试。');
			console.error('Logout error:', err);
		}
	};

	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>确认退出登录</DialogTitle>
				</DialogHeader>
				{error && (
					<Alert variant="destructive">
						<AlertDescription>{error}</AlertDescription>
					</Alert>
				)}
				<p>您确定要退出登录吗？</p>
				<DialogFooter>
					<Button variant="secondary" onClick={onClose}>
						取消
					</Button>
					<Button onClick={handleLogout} className="ml-2">
						确认
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default LogoutDialog;
